import { AbstractOptionalValidation } from "./abstractOptionalValidation";
import { stringToFloat } from "./number";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

export class MaximumNumberValidation extends AbstractOptionalValidation {
  key = "MaximumNumber";

  constructor(
    private readonly maximumNumber: number,
    isRequired: boolean,
    customMessage?: CustomErrorMessage
  ) {
    super(isRequired, customMessage);
  }

  validateValue(value: string): boolean {
    return stringToFloat(value) <= this.maximumNumber;
  }
}
